<template>
    <div
        data-component="AmsFilterContainer"
        class="transition-[padding-top] px-16"
        :class="{
            'py-16 border-t border-t-wildsand': rows.length,
            'py-0': !rows.length,
        }"
    >
        <div
            ref="containerRef"
            class="flex [&>*]:flex-shrink-0 gap-10 transition-[height] screen-m:flex-wrap overflow-x-scroll scrollbar-hide"
            :style="{ height: height + 'px' }"
        >
            <slot />
        </div>
        <cs-expander v-if="showExpander" v-model:expanded="expanded" />
    </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { CsExpander } from '@sunrise/components'
import { useRows } from './useRows'

const containerRef = ref<HTMLElement>()

const expanded = ref(false)

const showExpander = computed(() => rows.value.length > 1)

const height = computed(() => {
    const numberOfRowsToShow = showExpander.value && !expanded.value ? 1 : rows.value.length

    const firstRow = rows.value.at(0)
    const lastRow = rows.value.at(numberOfRowsToShow - 1)

    if (!firstRow || !lastRow) return 0

    return lastRow.maxBottom - firstRow.top
})

const rows = useRows(containerRef)
</script>
